import React, {useCallback, useMemo} from 'react';
import PropTypes from 'prop-types';
import {Button, Dropdown} from '@/components/atoms';
import {SectionTitle} from '@/components/molecules';
import {FONT_SIZE} from '@/utils/constants/globalStyle';

const CategoryWrapper = ({
  categories,
  selectedCategory,
  setSelectedCategory,
  selectedCategoryInitialState = []
}) => {
  const handleReset = useCallback(() => {
    // Reset the selected categories when reset is clicked
    setSelectedCategory(selectedCategoryInitialState);
  }, [setSelectedCategory, selectedCategoryInitialState]);

  const handleCategoryChange = useCallback(
    (value) => {
      setSelectedCategory(value);
    },
    [setSelectedCategory]
  );

  // Convert the backend data to the dropdown list format
  const dropdownList = useMemo(() => {
    return categories?.length
      ? categories.map((item) => ({
          displayText: item?.category,
          id: item?.categoryId,
          isBadge: false
        }))
      : [];
  }, [categories]);

  return (
    <>
      <div className='category-header-wrap mb-6'>
        <SectionTitle
          label='Select Categories to Include'
          fontSize={FONT_SIZE.XXXL}></SectionTitle>
        <Button
          handleButton={handleReset}
          uiSchema={{
            className: 'float-right',
            size: 'medium',
            title: 'Reset',
            variant: 'secondary',
            isDark: true
          }}
        />
      </div>
      <div className='grid grid-cols-4'>
        <Dropdown
          isJsonWrap={false}
          childList={dropdownList}
          isDark={true}
          label='Category *'
          placeholder={'Select Categories'}
          selection='multiple'
          updateValue={handleCategoryChange}
          size='medium'
          value={selectedCategory}
          hideMenuListOnSelection={false}
        />
      </div>
    </>
  );
};

CategoryWrapper.propTypes = {
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      category: PropTypes.string,
      categoryId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    })
  ),
  selectedCategory: PropTypes.array.isRequired,
  setSelectedCategory: PropTypes.func.isRequired,
  selectedCategoryInitialState: PropTypes.array
};

CategoryWrapper.defaultProps = {
  categories: [],
  selectedCategoryInitialState: []
};

export default React.memo(CategoryWrapper);
